import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "@/firebaseConfig";

import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/hls/id/:id",
    name: "video",
    params: true,
    component: () => import("../views/Video.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/mobile/id/:id",
    name: "mobilevideo",
    params: true,
    component: () => import("../views/MobileVideo.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/Admin.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/login",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: {
      requiresAuth: false,
      authRestricted: true
    }
  },
  {
    path: "/admin/videosmanager",
    name: "dashboard",
    params: true,
    component: () => import("../views/VideosManager.vue"),
    meta: {
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  const user = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const authRestricted = to.matched.some(record => record.meta.authRestricted);
  if (!user && requiresAuth) next("/admin/login");
  else if (user && authRestricted) next("/admin/videosmanager");
  else next();
});

export default router;
